<div>
  <!-- Left Sidebar -->
  <aside id="leftsidebar"
         class="sidebar"
         (mouseenter)="mouseHover()"
         (mouseleave)="mouseOut()">
    <!-- Menu -->
    <div class="menu">
      <ng-scrollbar [style.height]="listMaxHeight + 'px'"
                    visibility="hover">
        <ul class="list">
          <li class="sidebar-user-panel">
            <div class="user-panel">
              <div class=" image">
                @if (userImg) {
                  <img src={{userImg}}
                       class="img-circle user-img-circle"
                       alt="User Image" />
                } @else {
                  <span class="sidebar-user-initials img-circle user-img-circle">
                    {{ userInitials }}
                  </span>
                }
              </div>
            </div>
            <div class="profile-usertitle">
              <div class="sidebar-userpic-name">{{userFullName}} </div>
              <div class="profile-usertitle-job ">{{userType}} </div>
            </div>
          </li>
          <!-- Top Most level menu -->
          @for (sidebarItem of sidebarItems; track sidebarItem) {
          <li [class.active]="sidebarItem.submenu.length !== 0 && isExpanded(sidebarItem)"
              [routerLinkActive]="sidebarItem.submenu.length === 0 ? 'active-top' : ''">
            @if (sidebarItem.groupTitle === true) {
            <div class="header">{{sidebarItem.title | translate}}</div>
            }
            @if (!sidebarItem.groupTitle;) {
            <a [routerLink]="sidebarItem.class === '' ? [sidebarItem.path] : null"
               [ngClass]="[sidebarItem.class]"
               (click)="callToggleMenu($event, sidebarItem, sidebarItem.submenu.length)"
               class="menu-top">
              <i [ngClass]="[sidebarItem.iconType]">{{sidebarItem.icon}}</i>
              <span class="hide-menu">{{sidebarItem.title | translate}}
              </span>
              @if (sidebarItem.badge !== '' ) {
              <span [ngClass]="[sidebarItem.badgeClass]">{{sidebarItem.badge}}</span>
              }
            </a>
            }
            <!-- First level menu -->
            @if (sidebarItem.submenu.length > 0) {
            <ul class="ml-menu">
              @for (sidebarSubItem1 of sidebarItem.submenu; track sidebarSubItem1) {
              <li [class.active]="sidebarSubItem1.submenu.length > 0 && isExpanded(sidebarSubItem1)"
                  [routerLinkActive]="sidebarSubItem1.submenu.length === 0 ? 'active' : ''">
                <a [routerLink]="sidebarSubItem1.submenu.length > 0 ? null : [sidebarSubItem1.path]"
                   (click)="callToggleMenu($event, sidebarSubItem1, sidebarSubItem1.submenu.length)"
                   [ngClass]="[sidebarSubItem1.class]">
                  {{sidebarSubItem1.title | translate}}
                </a>
                <!-- Second level menu -->
                @if (sidebarSubItem1.submenu.length > 0) {
                <ul class="ml-menu-2">
                  @for (sidebarSubItem2 of sidebarSubItem1.submenu; track sidebarSubItem2) {
                  <li [class.active]="sidebarSubItem2.submenu.length > 0 && isExpanded(sidebarSubItem2)"
                      [routerLinkActive]="sidebarSubItem2.submenu.length === 0 ? 'active' : ''">
                    <a [routerLink]="sidebarSubItem2.submenu.length > 0 ? null : [sidebarSubItem2.path]"
                       (click)="callToggleMenu($event, sidebarSubItem2, sidebarSubItem2.submenu.length)"
                       [ngClass]="[sidebarSubItem2.class]">
                      {{sidebarSubItem2.title | translate}}
                    </a>
                    <!-- Third level menu -->
                    @if (sidebarSubItem2.submenu.length > 0) {
                    <ul class="ml-menu-3">
                      @for (sidebarSubItem3 of sidebarSubItem2.submenu; track sidebarSubItem3) {
                      <li [class.active]="sidebarSubItem3.submenu.length > 0 && isExpanded(sidebarSubItem3)"
                          [routerLinkActive]="sidebarSubItem3.submenu.length === 0 ? 'active' : ''">
                        <a [routerLink]="sidebarSubItem3.submenu.length > 0 ? null : [sidebarSubItem3.path]"
                           (click)="callToggleMenu($event, sidebarSubItem3, sidebarSubItem3.submenu.length)"
                           [ngClass]="[sidebarSubItem3.class]">
                          {{sidebarSubItem3.title | translate}}
                        </a>
                      </li>
                      }
                    </ul>
                    }
                  </li>
                  }
                </ul>
                }
              </li>
              }
            </ul>
            }
          </li>
          }
          <li class="logout-menu-item">
            <a class=""
               (click)="logout()"
               class="menu-top">
              <i class="material-icons-outlined">power_settings_new</i>
              <span class="hide-menu">{{ 'userProfileMenu.logout' | translate }}
              </span>
            </a>
          </li>
        </ul>
      </ng-scrollbar>
    </div>
    <!-- #Menu -->
  </aside>
  <!-- #END# Left Sidebar -->
</div>
